import React, { useMemo } from 'react';
import measurementsIcon from '#component/icon/measurements';
import { getYoungestMetrics } from '#component/device/helper';
import { InfoContainer, Info } from '#component/device/overview/styles';
import { isUndefinedOrNull } from '#helper';

function DeviceInfo(props) {
  const {
    device,
    account,
    loading,
    lastMetric
  } = props;

  const itemsToRender = useMemo(
    () =>
      getYoungestMetrics(lastMetric, account, ['temperature', 'humidity', 'battery']),
    [lastMetric, account]
  );

  return (
    <InfoContainer>
      {itemsToRender.length ? itemsToRender.map(item => (
        <Info key={item.identifier}>
          {loading ? null : measurementsIcon(item.identifier, device, item.value)}
          {!isUndefinedOrNull(item.value) ?
            <span>
              {item.value}
              {item.unit}
            </span> :
            null}
        </Info>
      )) : (
        <Info style={{ width: 24, height: 24 }} />
      )}
    </InfoContainer>
  );
}

export default DeviceInfo;
